module.exports = __webpack_public_path__ + "img/Spaziergang.5cab63fb.jpg";